import type { AppliedFilters } from '~/contracts/common';
import { logInfo } from '~/utilities/loggers';
import AppliedFiltersSchema from '~/validations/AppliedFilters';

export default function parseComposerFilters(
  filters: unknown
): Partial<AppliedFilters> | undefined {
  const result = AppliedFiltersSchema.safeParse(filters);

  if (!result.success) {
    logInfo('Composer UPDATE_SEARCH filters failed validation', {
      error: result.error,
      filters
    });

    return undefined;
  }

  return result.data;
}
